// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2b69f4fb396a289209f91467f888dc8c199d2d61/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};